<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
  <vl-layer-image
    :visible="overlay.visible"
    :opacity="overlay.opacity"
    :extent="overlayExtent"
    :z-index="overlay.zIndex"
  >
    <vl-source-image-static
      :url="overlay.url"
      :extent="overlayExtent"
      :size="overlaySize"
      :projection="projectionName"
      :load-func="imageLoadFunction"
    />
  </vl-layer-image>
</template>

<script>
import { get } from '@/utils/store-helpers';
import viewerImageContext from './mixins/viewer-image-context';

export default {
  name: 'heatmap-overlay-layer',
  mixins: [viewerImageContext],
  props: {
    index: String
  },
  computed: {
    shortTermToken: get('currentUser/shortTermToken'),
    overlay() {
      return this.imageWrapper.heatmapOverlay;
    },
    projectionName() {
      return `CYTO-${this.image.id}`;
    },
    imageExtent() {
      return [0, 0, this.image.width, this.image.height];
    },
    overlayExtent() {
      return this.overlay.extent || this.imageExtent;
    },
    overlaySize() {
      return this.overlay.size || [this.image.width, this.image.height];
    },
    imageLoadFunction() {
      return (image, src) => {
        const imageElement = image.getImage();

        if (this.isInlineOrObjectUrl(src)) {
          imageElement.src = src;
          return;
        }

        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';

        if (this.$keycloak && this.$keycloak.hasTemporaryToken) {
          const urlParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
          const accessToken = urlParams.get('access_token');
          if (accessToken) {
            const separator = src.includes('?') ? '&' : '?';
            src = `${src}${separator}access_token=${accessToken}`;
          }
          xhr.open('GET', src);
        } else {
          xhr.open('GET', src);
          if (this.shortTermToken) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.shortTermToken);
          }
        }

        xhr.addEventListener('load', () => {
          const url = URL.createObjectURL(xhr.response);
          imageElement.addEventListener('load', () => URL.revokeObjectURL(url), { once: true });
          imageElement.src = url;
        });
        xhr.send();
      };
    }
  },
  methods: {
    isInlineOrObjectUrl(url) {
      return url.startsWith('data:') || url.startsWith('blob:');
    }
  }
};
</script>
